import { useMemo } from "react";
import { getDatesFromItems } from "./getDatesFromItems";

export function useDatesFromItems(event, items, options = {}) {
    const { format } = options;

    return useMemo(() => {
        let result = getDatesFromItems(event, items);

        if (format) result = result.map((d) => d.format(format));

        return result;
    }, [event, items]);
}